import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  AUTH_GET_REQUEST,
  AUTH_GET_SUCCESS,
  AUTH_GET_FAILURE,
  TEMP_PASSWORD_CHANGE_SUCCESS,
  CHECK_IP_SUCCESS,
} from './actions';

import createReducer from 'state/createReducer';

import _ from 'lodash';

const initialState = {
  request: false,
  authRequest: false,
  ipIsBanned: false,
  bannedMinutes: 0,
  loggedIn: false,
  permissions: [],
  userDetails: {
    id: null,
    email: null,
    name: null,
    isTempPassword: null,
    verifyCode: null,
    role: {
      id: null,
      code: null,
      name: null
    }
  },
  isValidationError: false
}

const handlers = {

  [AUTH_GET_REQUEST](state) {
    return {
      ...state,
      authRequest: true
    }
  },

  [AUTH_GET_SUCCESS](state, payload) {
    return {
      ...state,
      loggedIn: true,
      permissions: _.get(payload, 'permissions', []),
      userDetails: {
        id: _.get(payload, 'id', null),
        email: _.get(payload, 'email', null),
        name: _.get(payload, 'name', null),
        isTempPassword: _.get(payload, 'isTempPassword', null),
        verifyCode: _.get(payload, 'verifyCode', null),
        getPORelatedEmails: _.get(payload, 'getPORelatedEmails', false),
        role: {
          id: _.get(payload, 'role.id', null),
          code: _.get(payload, 'role.code', null),
          name: _.get(payload, 'role.name', null),
        }
      },
    
      authRequest: false
    }
  },

  [AUTH_GET_FAILURE](state) {
    return {
      ...state,
      loggedIn: false,
      permissions: [],
      userDetails: null,
      authRequest: false
    }
  },

  [LOGIN_REQUEST] (state) {
    return {
      ...state,
      request: true,
      authRequest: false,
      permissions: [],
      userDetails: null,
      isValidationError: false
    }
  },

  [LOGIN_SUCCESS] (state) {
    return {
      ...state,
      request: false,
      authRequest: true,
      isValidationError: false,
      loggedIn: true,
      ipIsBanned: false,
      bannedMinutes: 0,
    }
  },

  [LOGIN_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      authRequest: false,
      loggedIn: false,
      permissions: [],
      userDetails: null,
      isValidationError: _.get(payload, 'isValidationError', false)
    }
  },

  [LOGOUT_SUCCESS](state) {
    return {
      ...state,
      request: false,
      authRequest: false,
      loggedIn: false,
      isValidationError: false,
      permissions: [],
      userDetails: null
    }
  },

  [TEMP_PASSWORD_CHANGE_SUCCESS](state, payload) {

    if ( _.has(state, 'userDetails.isTempPassword') === false ) {
      return {
        ...state
      }
    }

    const userDetails = _.cloneDeep(state.userDetails);
    userDetails.isTempPassword = false;

    return {
      ...state,
      userDetails: userDetails
    }
  },
  
  [CHECK_IP_SUCCESS](state, payload) {
    
    if (payload.isBanned === true) {
      return {
        ...state,
        ipIsBanned: payload.isBanned,
        bannedMinutes: payload.minutes,
        loggedIn: false,
        permissions: [],
        userDetails: null
      }
    } else {
      return {
        ...state,
        ipIsBanned: payload.isBanned,
        bannedMinutes: payload.minutes
      }
    }
    
    
  },

}

export default (state = initialState, action) => createReducer(state, action, handlers);
